<script>
import BFields from "@components/bosons/b-fields";

import AInput from "@components/atoms/a-input.vue";
import AText from "@components/atoms/a-text.vue";

export default {
  name: "MFieldText",
  mixins: [BFields],
  components: {
    AInput,
    AText,
  },
};
</script>

<template lang="pug">
  div(class="m-fieldText flex flex-col")
    AText(
      v-if="hasLabel"
      :for="`${name}_${_uid}`"
      :content="label"
      tag="label"
      class="mb-2"
      )
    AInput(
      class="rounded-1/4 px-4 font-medium text-base leading-tall"
      :id="`${name}_${_uid}`"
      :name="name"
      :mask="mask"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      :minlength="minlength || null"
      :maxlength="maxlength || null"
      @change="input"
      @blur="blur"
      @keyup="keyup"
      :disabled="disabled"
      :list="`${name}`"
      :class="{'a-input--error text-error hover:text-error border-error hover:border-error focus:border-error': error.status.$error}"
    )
    datalist(
      v-if="type === 'email'"
      :id="`${name}`"
    )
      option(
        v-for="(item, i) in newEmailList",
        :value="item",
        :key="`${_uid}-${i}_${item}`",
      )
    slot
    AText(
      v-if="error.status.$error"
      :content="filterErrors()[0].message"
      tag="span"
      class="mt-1 text-error"
      )
</template>

<style scoped>
input.a-input--error,
input.a-input--error:focus,
input.a-input--error:not(:placeholder-shown),
input.a-input--error:not(:placeholder-shown):focus {
  @apply border-error;
}
</style>
